import {slices} from 'store';
import type {Dispatch} from 'redux';

export function uploadStart(dispatch: Dispatch, id: string) {
  return () => {
    dispatch(slices.transfers.actions.upload({id}));
  }
}

export function uploadEnd(dispatch: Dispatch) {
  return () => {
    dispatch(slices.transfers.actions.upload({id: null}));
  }
}

export function uploadMinimize(dispatch: Dispatch, minimized: boolean) {
  return () => {
    dispatch(slices.transfers.actions.uploadMinimize({minimized}));
  }
}

export function downloadMinimized(dispatch: Dispatch, minimized: boolean) {
  return () => {
    dispatch(slices.transfers.actions.downloadMinimize({minimized}));
  }
}
